<template>
  <page-view class="max-height shopline">
    <div class="loading-spinner large m-a"></div>
  </page-view>
</template>

<style lang="scss" scoped>
</style>

<script>

import { getQueryParameterValue } from '@/utils';

export default {
  mounted() {
    this.$store.commit('Theme/shoplineMode');
    if (this.shoppingSettings?.provider === 'shopline') {
      this.$router.replace('/dashboard');
      return;
    }

    const appkey = getQueryParameterValue('appkey');
    // eslint-disable-next-line
    const timestamp = getQueryParameterValue('timestamp');
    // eslint-disable-next-line
    const sign = getQueryParameterValue('sign');
    const handle = getQueryParameterValue('handle');
    // eslint-disable-next-line
    const lang = getQueryParameterValue('lang');

    if (!appkey && !handle) {
      this.$router.replace('/dashboard');
      return;
    }

    if (window.self !== window.top) {
      window.parent.location.href = `https://${handle}.myshopline.com/admin/oauth-web/#/oauth/authorize?appKey=${appkey}&responseType=code&scope=read_products,read_markets,write_script_tags,read_store_information&redirectUri=https://app.streamify.io/settings/liveshopping/oauth/shopline`;
    } else {
      window.location.href = `https://${handle}.myshopline.com/admin/oauth-web/#/oauth/authorize?appKey=${appkey}&responseType=code&scope=read_products,read_markets,write_script_tags,read_store_information&redirectUri=https://app.streamify.io/settings/liveshopping/oauth/shopline`;
    }
  },
};
</script>
